var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"font-size-16"},_vm._l((_vm.title.split(' ')),function(part,key){return _c('span',{key:key},[(key < _vm.title.split(' ').length-1)?_c('span',{staticClass:"title-colored-part"},[_vm._v(_vm._s(part)+" ")]):_c('span',{staticClass:"title-mode-part"},[_vm._v(_vm._s(part))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }